export default __webpack_public_path__ + "static/starblitzHeroFoliage-e61ccfbf14ad7cb90dec8d9058376b5e.png";